import React, { useState } from "react";
import Checkbox, {
  checkboxStates,
} from "@visiblethread/react-components/dist/components/Checkbox";
import PropTypes from "prop-types";
import folderIcon from "icons/dictionary/folder.svg";
import lockImage from "icons/dictionary/lock.svg";
import { getDictionaryPath } from "constants/routes";
import { Link } from "react-router-dom";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { useDispatch } from "react-redux";

const DictionaryTableItem = ({ item, columnWidths }) => {
  const dispatch = useDispatch();
  const { folders, documents } = item.usedBy;
  const {
    id,
    name,
    description,
    createdBy,
    createdOn,
    lastUpdated,
    inUse,
    lastUsed,
    locked,
    defaultDictionary,
  } = item;
  const [hover, setHover] = useState(false);

  const foldersAndDocs = () => {
    const foldersLength = folders.length;
    const documentsLength = documents.length;
    const folderMessage = `${foldersLength} Folder${
      foldersLength > 1 ? "s" : ""
    }`;
    const docsMessage = `${documentsLength} Document${
      documentsLength > 1 ? "s" : ""
    }`;
    let message = "";
    if (foldersLength > 0 && documentsLength > 0) {
      message = `${folderMessage} \\ ${docsMessage}`;
    }
    if (foldersLength === 0) {
      message = docsMessage;
    }
    if (documentsLength === 0) {
      message = folderMessage;
    }
    return message;
  };

  const handleClick = (e) => {
    if (e.target.classList.contains("used_by_stats")) {
      e.preventDefault();
      dispatch(
        showModal(modalTypes.DICTIONARY_FOLDER_DOC_INFO, {
          dictionaryName: item.name,
          folders,
          documents,
        })
      );
    }
  };

  return (
    <Link to={getDictionaryPath(id)} onClick={(e) => handleClick(e)}>
      <div
        className={`dictionary__table__body__item ${hover ? "hover" : ""}`}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        data-testid="item"
      >
        {locked ? (
          <span className="dictionary__table__body__item-lock">
            <img src={lockImage} alt="lock" />
          </span>
        ) : (
          <span>&nbsp;</span>
        )}
        <span
          style={{ width: columnWidths[0] }}
          title={description || null}
          className={`${
            defaultDictionary ? "default" : ""
          } dictionary__table__body__item-dictionary`}
        >
          {name}
        </span>
        <span
          style={{ width: columnWidths[1] }}
          className="dictionary__table__body__item-created_by"
        >
          {createdBy || "System"}
        </span>
        <span
          style={{ width: columnWidths[2] }}
          className="dictionary__table__body__item-created_on"
        >
          {createdOn}
        </span>
        <span
          style={{ width: columnWidths[3] }}
          className="dictionary__table__body__item-last_updated"
        >
          {lastUpdated}
        </span>
        <span
          style={{ width: columnWidths[4] }}
          className="dictionary__table__body__item-in_use"
        >
          {inUse ? (
            <Checkbox
              state={checkboxStates.checked}
              handleChange={() => {}}
              disabled
              id="dictionary_table_item__in_use_checkbox"
              value="dictionary_table_item__in_use_checkbox"
            />
          ) : (
            <span>&nbsp;</span>
          )}
        </span>
        <span
          style={{ width: columnWidths[5] }}
          className="dictionary__table__body__item-used_by"
        >
          {inUse ? (
            <span className="used_by_stats">
              <img src={folderIcon} alt="folders" />
              {foldersAndDocs()}
            </span>
          ) : null}
        </span>
        <span
          style={{ width: columnWidths[6] }}
          className="dictionary__table__body__item-last_used"
        >
          {lastUsed}
        </span>
      </div>
    </Link>
  );
};

export default DictionaryTableItem;

DictionaryTableItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    createdBy: PropTypes.string,
    createdOn: PropTypes.string.isRequired,
    lastUpdated: PropTypes.string.isRequired,
    inUse: PropTypes.bool.isRequired,
    lastUsed: PropTypes.string,
    locked: PropTypes.bool.isRequired,
    defaultDictionary: PropTypes.bool.isRequired,
    usedBy: PropTypes.shape({
      folders: PropTypes.arrayOf(PropTypes.string),
      documents: PropTypes.arrayOf(PropTypes.string),
    }),
  }),
  columnWidths: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
};
